export enum ScanSessionStatus {
    Active = 0,
    Complete = 1,
    Interrupted = 2,
    Unknown = 3
  }
  